
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function Demande() {
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [user, setUser] = useState();
  const [packs, setPacks] = useState([]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  // const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    const fetchUserAndPacks = async () => {
      try {
        const auth = localStorage.getItem("user");
        if (auth) setUser(JSON.parse(auth));

        const response = await axios.get(`${baseUrl}/packs`);
        setPacks(response.data.packs);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchUserAndPacks();
  }, [baseUrl]);

  const handlePackSelect = (pack) => {
    console.log(
      `user pack price == ${user?.membership?.membership_packs?.price} || membership pack price == ${pack.price}`
    );
    console.log(`user free pack value == ${user?.free_pack}`);
    console.log(`user membership_id  == ${user?.membership?.membership_id}`);

    if (
      pack?.order == 1 &&
      (user?.membership?.membership_id == 6 || user?.free_pack == 1)
    ) {
      setMessage(`You are already a free member.`);
      setError(null);
      setTimeout(() => {
        setMessage(null);
      }, 2000);
    } else {
      if (user?.membership?.membership_packs?.id == pack.id) {
        setMessage(`You are already a ${pack.name} member`);
        setError(null);
        setTimeout(() => {
          setMessage(null);
        }, 2000);
      } else {
        if (
          Number.parseInt(user?.membership?.membership_packs?.price) >
          Number.parseInt(pack.price)
        ) {
          setError(`You can't downgrade your pack.`);
          setMessage(null);
          setTimeout(() => {
            setError(null);
          }, 2000);
        } else {
          navigate("/membership/welcometwo", {
            state: {
              pack: pack,
              id: pack?.id,
              price: pack?.price,
            },
          });
        }
      }
    }
  };

  const renderComparisonTable = () => {
    return (
      <div className="w-full max-w-4xl mx-auto mb-12 px-2">
        <h2 className="text-2xl font-bold text-white text-center mb-8">
          {t("comparisan.Comparez")}
        </h2>

        <div className="bg-gray-800 rounded-xl overflow-hidden">
          {/* Header Row */}
          <div
            className="grid grid-cols-4 border-b border-gray-600"
            style={{ backgroundColor: "rgba(96, 141, 64,0.2)" }}
          >
            <div className="p-4"></div>
            <div className="p-4 text-center">
              <span className="text-white font-semibold text-sm">
                Non Golfer
              </span>
            </div>
            <div className="p-4 text-center">
              <span className="text-white font-semibold text-sm">Golfer</span>
            </div>
            <div className="p-4 text-center">
              <span className="text-white font-semibold text-sm">Premium</span>
            </div>
          </div>

          {/* Feature Rows */}
          {[
            { feature: "Conferences", values: ["2", "2", "2"] },
            { feature: "Initiation", values: ["5", "×", "×"] },
            { feature: "GTM Cup / Industry Outings", values: ["×", "5", "7"] },
            { feature: "Longest Drive", values: ["1", "1", "1"] },
            { feature: "Art", values: ["2", "2", "2"] },
            { feature: "Big Smoke", values: ["1", "1", "1"] },
            { feature: "Classic Cars", values: ["1", "1", "1"] },
            // { feature: "Membership Roster", values: ["×", "×", "✓"] },
          ].map((row, index) => (
            <div
              key={index}
              className="grid grid-cols-4 border-b border-gray-600 last:border-b-0"
            >
              <div className="p-4">
                <span className="text-white text-sm">{row.feature}</span>
              </div>
              {row.values.map((value, i) => (
                <div key={i} className="p-4 text-center">
                  <span className="text-gray-300 text-sm">{value}</span>
                </div>
              ))}
            </div>
          ))}
          <div className="grid grid-cols-4 border-b border-gray-600 last:border-b-0" style={{ backgroundColor: "rgba(96, 141, 64,0.2)" }}>
            <div className="p-4">Total</div>
            <div className="p-4 text-center">
              <span className="text-white font-semibold text-sm">
                12
              </span>
            </div>
            <div className="p-4 text-center">
              <span className="text-white font-semibold text-sm">12</span>
            </div>
            <div className="p-4 text-center">
              <span className="text-white font-semibold text-sm">14</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderPricingCard = (pack, index, isLastCard) => {
    const isPopular = pack?.order === 4;

    return (
      <div
        key={pack?.id}
        className="w-full max-w-[250px] h-[320px] bg-opacity-80 border border-white border-opacity-20 rounded-2xl overflow-hidden relative"
      >
        {isPopular && (
          <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
            <div className="bg-white px-4 py-1 rounded-full">
              <span className="text-black text-xs font-semibold">
                {t("comparisan.Populaire")}
              </span>
            </div>
          </div>
        )}

        <button
          onClick={() => handlePackSelect(pack)}
          className="w-full h-full rounded-2xl overflow-hidden hover:opacity-90 transition-opacity"
        >
          {isLastCard ? (
            // Premium card with background image
            <div
              className="p-4 h-full flex flex-col justify-between"
              style={{
                backgroundImage: `url(${pack.background ?? pack.second_image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div>
                <h3 className="text-base font-bold text-white mb-1 capitalize">
                  {pack.name}
                </h3>
                <div className="mb-2">
                  <span className="text-lg font-bold text-white">
                    {pack?.price.length > 4
                      ? `${pack?.price.toString().slice(0, 2)} ${pack?.price
                          .toString()
                          .slice(2)}`
                      : `${pack?.price.toString().slice(0, 1)} ${pack?.price
                          .toString()
                          .slice(1)}`}
                  </span>
                  <span className="text-xs font-semibold text-white ml-1">
                    MAD
                  </span>
                  <p className="text-gray-300 text-xs">
                    TTC /{t("comparisan.annuel")}
                  </p>
                </div>

                <div className="overflow-y-auto h-[150px] space-y-1 pr-1 text-xs">
                  {pack?.order === 2 && (
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-green-500 text-xs" />
                      <span className="text-white">5 Initiation</span>
                    </div>
                  )}
                  {pack?.order === 3 && (
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-green-500 text-xs" />
                      <span className="text-white text-start">
                        5 GTM Cup / Industry Outings
                      </span>
                    </div>
                  )}
                  {pack?.order === 4 && (
                    <div className="flex items-center gap-2">
                      <FaCheck className="text-green-500 text-xs" />
                      <span className="text-white text-start">
                        7 GTM Cup / Industry Outings
                      </span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <FaCheck className="text-green-500 text-xs" />
                    <span className="text-white">2 Conferences</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCheck className="text-green-500 text-xs" />
                    <span className="text-white">1 Longest Drive</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCheck className="text-green-500 text-xs" />
                    <span className="text-white">2 Art</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCheck className="text-green-500 text-xs" />
                    <span className="text-white">1 Big Smoke</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <FaCheck className="text-green-500 text-xs" />
                    <span className="text-white">1 Classic Cars</span>
                  </div>
                </div>
              </div>

              <div className="bg-white bg-opacity-90 py-2 rounded-xl text-center mt-2">
                <span
                  style={{
                    color: pack?.color,
                  }}
                  className=" text-xs font-bold"
                >
                  {t("comparisan.Abonnez-vous")}
                </span>
              </div>
            </div>
          ) : (
            // Other cards with linear gradient
            <div
              className="p-4 h-full flex flex-col justify-between"
              style={{
                background:
                  "linear-gradient(135deg, rgba(96,141,64,0.2) 0%, rgba(96,141,64,0.05) 100%)",
              }}
            >
              <div>
                <h3 className="text-base font-bold text-white mb-1 capitalize">
                  {pack?.name
                    ?.slice(0, 1)
                    .toUpperCase()
                    .concat(pack?.name.slice(1))}
                </h3>
                <div className="mb-2">
                  <span className="text-lg font-bold text-white">
                    {pack?.price.length > 4
                      ? `${pack?.price.toString().slice(0, 2)} ${pack?.price
                          .toString()
                          .slice(2)}`
                      : `${pack?.price.toString().slice(0, 1)} ${pack?.price
                          .toString()
                          .slice(1)}`}
                  </span>
                  <span className="text-xs font-semibold text-white ml-1">
                    MAD
                  </span>
                  <p className="text-gray-300 text-xs">
                    TTC /{t("comparisan.annuel")}
                  </p>
                </div>

                <div className="space-y-1 text-xs mb-2 overflow-y-auto h-[150px] pr-1">
                  {pack?.order === 1 || pack?.price === "0" ? (
                    <>
                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white text-start">
                          Consultez le programme de golf GTM
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white text-start">
                          Consultez les événements nationaux de golf
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white">2 Conferences</span>
                      </div>

                      {pack?.order === 2 && (
                        <div className="flex items-center gap-2">
                          <FaCheck className="text-green-500 text-xs" />
                          <span className="text-white">5 Initiation</span>
                        </div>
                      )}

                      {pack?.order === 3 && (
                        <div className="flex items-center gap-2">
                          <FaCheck className="text-green-500 text-xs" />
                          <span className="text-white text-start">
                            5 GTM Cup / Industry Outings
                          </span>
                        </div>
                      )}

                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white">1 Longest Drive</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white">2 Art</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white">1 Big Smoke</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <FaCheck className="text-green-500 text-xs" />
                        <span className="text-white">1 Classic Cars</span>
                      </div>

                      {pack?.order === 4 && (
                        <div className="flex items-center gap-2">
                          <FaCheck className="text-green-500 text-xs" />
                          <span className="text-white">Roster</span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div
                className="py-2 rounded-xl text-center mt-2"
                style={{
                  backgroundColor:
                    pack?.background || pack?.second_image || "#608D40",
                  backgroundImage:
                    pack?.background || pack?.second_image
                      ? `url(${pack?.background || pack?.second_image})`
                      : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <span className="text-black text-xs font-bold">
                  {t("comparisan.Abonnez-vous")}
                </span>
              </div>
            </div>
          )}
        </button>
      </div>
    );
  };

  return (
    <div className="bg-black shadow-custom text-white h-full bg-opacity-[87%] flex flex-col items-center justify-start gap-4 md:gap-10 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
      <div className="container mx-auto lg:px-4 px-2 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            {t("comparisan.Choisissez")}
            <br />
            {t("comparisan.ideal")}
          </h1>
          <p className="text-gray-300 text-lg mb-4 max-w-2xl mx-auto">
            {t("comparisan.Débloquez")}
          </p>
          <p className="text-white text-lg font-semibold mb-12">
            Non Golfer, Golfer {t("comparisan.ou")} Premium.
          </p>
        </div>

        {/* Comparison Table */}
        {renderComparisonTable()}

        {/* Free Card */}
        {/* {renderFreeCard()} */}

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12 max-w-6xl mx-auto justify-items-center">
          {loading ? (
            <div className="col-span-full flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
            </div>
          ) : (
            packs
              .sort((a, b) => a.order - b.order)
              ?.map((pack, index) => {
                const isLastCard = index === packs.length - 1;
                return renderPricingCard(pack, index, isLastCard);
              })
          )}
        </div>

        {/* Messages */}
        {message && (
          <div className="text-center mb-4">
            <p className="text-green-500 font-semibold">{message}</p>
          </div>
        )}
        {error && (
          <div className="text-center mb-4">
            <p className="text-red-500 font-semibold">{error}</p>
          </div>
        )}

        {/* FAQ Section */}
        <div className="max-w-4xl mx-auto mb-12">
          <h2 className="text-3xl font-bold text-center mb-8">
            {t("comparisan.FAQ")}
          </h2>

          <div className="space-y-4">
            <div className="bg-gray-800 rounded-xl p-6">
              <h3 className="text-lg font-semibold text-white mb-2">
                {t("comparisan.puis_je")}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {t("comparisan.oui_vous")}
              </p>
            </div>

            <div className="bg-gray-800 rounded-xl p-6">
              <h3 className="text-lg font-semibold text-white mb-2">
                {t("comparisan.Mes_donnees")}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {t("comparisan.Nous_utilisons")}
              </p>
            </div>

            <div className="bg-gray-800 rounded-xl p-6">
              <h3 className="text-lg font-semibold text-white mb-2">
                {t("comparisan.Puis_je_upgrader")}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {t("comparisan.vous_pouvez_upgrader")}
              </p>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="text-center mb-8">
          <p className="text-gray-500 text-xs">
            {t("comparisan.En_vous_abonnant")}
          </p>
        </div>
      </div>
    </div>
  );
}